import { useTranslation } from 'react-i18next'

import {
  useContentOverflow,
  useDateLocale,
  useTimeZone,
} from '../../../../../hooks'
import { FloatingTooltip } from '../../../../Floating'
import { getListingUnitLabel } from '../../../../RentalPortalListing'
import Text from '../../../../Text'
import { getOverviewApprovalSelectedFact } from '../RentalPortalOverviewApprovalRow.utils'

import * as styles from './OverviewApprovalSubtitle.module.css'

function OverviewApprovalSubtitle({ row }) {
  const { t } = useTranslation()

  const locale = useDateLocale()
  const timezone = useTimeZone()

  const unitLabel = getListingUnitLabel({ listing: row, t })

  const { overflow, setContentOverflowRef } = useContentOverflow()

  return (
    <span className={styles.OverviewApprovalSubtitle}>
      <FloatingTooltip content={unitLabel} disabled={!overflow}>
        <Text isSecondary className={styles.unit} ref={setContentOverflowRef}>
          {unitLabel}
        </Text>
      </FloatingTooltip>
      <Text isSecondary className={styles.selected}>
        {getOverviewApprovalSelectedFact({ locale, row, t, timezone })}
      </Text>
    </span>
  )
}

export default OverviewApprovalSubtitle
